// Reține unde voia utilizatorul să ajungă (ex: un link de invitație)
// când e trimis la login, ca să-l ducem înapoi acolo după autentificare.
const KEY = "chit_redirect_after_login";

export function setRedirect(path) {
  if (path && path !== "/" && !path.startsWith("/login")) {
    localStorage.setItem(KEY, path);
  }
}

export function consumeRedirect() {
  const p = localStorage.getItem(KEY);
  localStorage.removeItem(KEY);
  return p || "/";
}

// Citește destinația salvată FĂRĂ a o șterge (pt. banner-ul de pe login).
export function peekRedirect() {
  return localStorage.getItem(KEY);
}
